import { siteConfig } from "../config/site";

interface BrandLogoProps {
  compact?: boolean;
}

export function BrandLogo({ compact = false }: BrandLogoProps) {
  return (
    <span className={`brand-logo ${compact ? "brand-logo--compact" : ""}`}>
      <img src="/assets/logo-mark-v3.svg" alt="" width={52} height={52} />
      <span className="brand-product-name">{siteConfig.logoName}</span>
    </span>
  );
}
